import {
  INIT_POI_DETAILS,
  FETCH_POI,
  FETCH_POI_PRODUCTS,
  SHOW_DESCRIPTTION,
  SET_CURRENT_IMG,
  POI_POPUP,
  SET_CURRENT_TRIP,
  FETCH_TRIP_OF_POI_DETAILS,
  BACK_TO_STEP1,
  SET_CURRENT_DAY,
  ADD_POI_OF_POIPAGE_TO_TRIP,
  SET_DETAIL_CARD
} from '../actionTypes/poiDetail';
import { checkImgType } from '../utilities/image_util';
import { formatDayHasPoi } from '../utilities/format_pois_util';
import {
  REQUEST,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_LOADING
} from '../actions/action_types';

const DESCRIPTION = {
  BEGIN_INDEX: 0,
  LIMIT: 50
};
const STEP_CONFIG = {
  STEP1: 1,
  STEP2: 2
};

const initState = {
  data: {},
  isDetailCardShow: true,
  isLoading: true,
  isHiddenDescription: false,
  isShowPopup: false,
  stepType: STEP_CONFIG.STEP1,
  currentImg: '',
  currentTrip: {},
  currentDay: 0,
  isGetCurrentTripLoading: false,
  isAddToTripLoading: false,
  isAddToCollectionLoading: false,
  isAddToTripStatus: REQUEST.INIT
};

export default (state = { ...initState }, action) => {
  switch (action.type) {
    case INIT_POI_DETAILS:
      return initState;
    case FETCH_POI.LOADING:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_POI.SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        products: [], // purge
        isHiddenDescription: checkDescriptionLength(action.payload.data),
        currentImg: action.payload.data.photos[0]
          ? checkImgType({
              data: action.payload.data.photos[0],
              widthLimit: 600
            })
          : ''
      };
    case FETCH_POI.FAIL:
      return {
        ...state,
        isLoading: false
      };
    case FETCH_POI_PRODUCTS.LOADING:
      return {
        ...state,
        products: [], // purge
        isLoading: true
      };
    case FETCH_POI_PRODUCTS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        products: action.payload.data
      };
    case FETCH_POI_PRODUCTS.FAIL:
      return {
        ...state,
        isLoading: false
      };
    case FETCH_TRIP_OF_POI_DETAILS.LOADING:
      return {
        ...state,
        isGetCurrentTripLoading: true,
        stepType: STEP_CONFIG.STEP2
      };
    case ADD_TRIP_LOADING:
      return {
        ...state,
        isGetCurrentTripLoading: true
      };
    case FETCH_TRIP_OF_POI_DETAILS.SUCCESS:
      return setPoiAndDayOfTrips(state, action);
    case ADD_TRIP_SUCCESS: {
      const trip = action.payload.results;
      return {
        ...state,
        currentTrip: { ...trip },
        isGetCurrentTripLoading: false
      };
    }
    case FETCH_TRIP_OF_POI_DETAILS.FAIL:
      return {
        ...state,
        isGetCurrentTripLoading: false,
        stepType: STEP_CONFIG.STEP1
      };
    case SHOW_DESCRIPTTION:
      return {
        ...state,
        isHiddenDescription: false
      };
    case SET_CURRENT_IMG:
      return {
        ...state,
        currentImg: action.currentImg
      };
    case SET_CURRENT_TRIP:
      return {
        ...state,
        currentTrip: action.currentTrip,
        stepType: STEP_CONFIG.STEP2
      };
    case SET_CURRENT_DAY:
      return {
        ...state,
        currentDay: action.currentDay
      };
    case POI_POPUP.SHOW:
      return {
        ...state,
        isShowPopup: true,
        stepType: STEP_CONFIG.STEP1
      };
    case POI_POPUP.CLOSE:
      return {
        ...state,
        isShowPopup: false,
        currentTrip: {},
        currentDay: 0,
        stepType: STEP_CONFIG.STEP1
      };
    case BACK_TO_STEP1:
      return {
        ...state,
        stepType: STEP_CONFIG.STEP1,
        currentTrip: {},
        currentDay: 0
      };
    case ADD_POI_OF_POIPAGE_TO_TRIP.INIT:
      return {
        ...state,
        isAddToTripLoading: false,
        isAddToTripStatus: REQUEST.INIT
      };
    case ADD_POI_OF_POIPAGE_TO_TRIP.LOADING:
      return {
        ...state,
        isAddToTripLoading: true,
        isAddToTripStatus: REQUEST.LOADING
      };
    case ADD_POI_OF_POIPAGE_TO_TRIP.SUCCESS:
      return {
        ...state,
        isAddToTripLoading: false,
        isAddToTripStatus: REQUEST.SUCCESS,
        stepType: STEP_CONFIG.STEP1,
        isShowPopup: false,
        currentTrip: {},
        currentDay: 0
      };
    case ADD_POI_OF_POIPAGE_TO_TRIP.FAIL:
      return {
        ...state,
        isAddToTripLoading: false,
        isAddToTripStatus: REQUEST.FAIL,
        stepType: STEP_CONFIG.STEP1,
        isShowPopup: false,
        currentTrip: {},
        currentDay: 0
      };
    case SET_DETAIL_CARD:
      return {
        ...state,
        isDetailCardShow: action.isShow
      };

    default:
      return state;
  }
};

const checkDescriptionLength = data => {
  if (data && data.description) {
    return data.description.length > DESCRIPTION.LIMIT;
  }
  return false;
};

const setPoiAndDayOfTrips = (state, action) => {
  const trip = action.payload;
  const dayWithPois = formatDayHasPoi(trip);

  return {
    ...state,
    currentTrip: { ...trip, dayWithPois },
    isGetCurrentTripLoading: false,
    stepType: STEP_CONFIG.STEP2
  };
};
